<template lang="pug">
  c-picker(v-model="color")
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  components: { 'c-picker': Chrome },
  props: [ 'value' ],
  data: () => ({
    color: '#ffffff'
  }),
  mounted () {
    this.setColor(this.value)
  },
  methods: {
    setColor (color) {
      if (color) this.color = color
    },
    emitValue (color) {
      if (color.hex) this.$emit('input', color.hex)
    }
  },
  watch: {
    color (val) {
      this.emitValue(val)
    },
    value (val) {
      this.setColor(val)
    }
  }
}
</script>
